/*eslint-env node*/
const seminarAdvance = {
  mainTitle: "ADVANCED SEMINAR",
  mainDesc:
    "Untuk pertama kalinya, COMPFEST akan menghadirkan Advanced Seminar yang mengakomodasi kesempatan lebih untuk berinteraksi secara mendalam dengan pembicara berpengalaman kami. Peserta Seminar ini  juga dapat membuat koneksi ke komunitas yang lebih luas melalui <i> networking session. </i>",
  seminarData: [
    {
      title:
        "The Intelligence of Big Data Implementation in Automating the Hyperconnected World",
      place: "Balai Sidang Universitas Indonesia",
      date: "Sabtu, 21 September 2019",
      time: "09.00–11.30",
      price: "Rp50.000/Attendance",
      color: "#D40F37",
      detail: "/seminar/detail/advanced",
      daftar: "/seminar/detail/advanced",
      speakers: [
        {
          name: "Vira Shanty",
          desc: "Chief Data Officer at OVO",
          image: require("images/speakers/Vira Shanty.jpg"),
        },
        {
          name: "Dewi Liliana",
          desc: "Machine Learning Researcher and Alumni Doctoral Fasilkom UI",
          image: require("images/speakers/Dewi Liliana.jpg"),
        },
        {
          name: "Iskak Hendrawan",
          desc: "Chief Information & Technology Officer Prudential Indonesia",
          image: require("images/speakers/Iskak Hendrawan.jpeg"),
        },
      ],
    },
  ],
};

const seminar = {
  mainTitle: "SEMINAR",
  mainDesc:
    "Tahun ini, Seminar akan membawakan topik-topik yang menarik seperti <i> cyber security, mixed reality, startup, blockchain, </i> dan masih banyak lagi. Seminar adalah kesempatan terbaik untuk memperluas pengetahuan di bidang teknologi.",
  seminarData: [
    {
      title:
        "Artificial Intelligence: Mankind's Last Invention That Change the World",
      place: "Auditorium Fakultas Ilmu Komputer UI Gedung Baru",
      date: "Sabtu, 14 September 2019",
      time: "09.00–11.30",
      price: "FREE",
      color: "#0088D2",
      detail: "/seminar/detail/artificial-intelligence",
      daftar: "/seminar/detail/artificial-intelligence",
      speakers: [
        {
          name: "Irvan Bastian Arief",
          desc: "Head of Research Scientist at Tokopedia",
          image: require("images/speakers/Irvan Bastian Arief.jpg"),
        },
      ],
    },
    {
      title: "Cyber Security: How Secure and Valuable is Your Data?",
      place: "Auditorium Fakultas Ilmu Komputer UI Gedung Baru",
      date: "Sabtu, 14 September 2019",
      time: "12.00–14.30",
      price: "FREE",
      color: "#0088D2",
      detail: "/seminar/detail/cyber-security",
      daftar: "/seminar/detail/cyber-security",
      speakers: [
        {
          name: "Muhammad Endhy Aziz",
          desc: "Cybersecurity Specialist at BSSN",
          image: require("images/speakers/Muhammad Endhy Aziz.jpg"),
        },
      ],
    },
    {
      title: "Uncovered Massive Disruption from Blockchain",
      place: "Auditorium Fakultas Ilmu Komputer UI Gedung Baru",
      date: "Sabtu, 14 September 2019",
      time: "14.30–16.30",
      price: "FREE",
      color: "#0088D2",
      detail: "/seminar/detail/blockchain",
      daftar: "/seminar/detail/blockchain",
      speakers: [
        {
          name: "Patria Abditiar",
          desc: "Chief Growth Officer at Kendi.io",
          image: require("images/speakers/Patria Abditiar.jpeg"),
        },
      ],
    },
    {
      title:
        "Business Intelligence 101: Improve Your Startup Through Data Optimization",
      place: "Auditorium Fakultas Ilmu Komputer UI Gedung Baru",
      date: "Minggu, 15 September 2019",
      time: "09.00–11.30",
      price: "FREE",
      color: "#0088D2",
      detail: "/seminar/detail/business-intelligence",
      daftar: "/seminar/detail/business-intelligence",
      speakers: [
        {
          name: "Abdul Karim",
          desc: "OMS and Smart Operation Engineer Lead at DHL Supply Chain",
          image: require("images/speakers/Abdul Karim.jpg"),
        },
        {
          name: "Haniff Alkaff",
          desc: "Head of Data and Analytics at Futuready",
          image: require("images/speakers/Haniff Alkaff.jpg"),
        },
        {
          name: "Zanipar Siadari",
          desc: "Senior Manager Product Marketing PT. Epson Indonesia",
          image: require("images/speakers/Zanipar Siadari.jpg"),
        },
      ],
    },
    {
      title: "How Gamification Drive Better Business Outcome",
      place: "Auditorium Fakultas Ilmu Komputer UI Gedung Baru",
      date: "Minggu, 15 September 2019",
      time: "12.00–14.30",
      color: "#0088D2",
      price: "FREE",
      detail: "/seminar/detail/gamification",
      daftar: "/seminar/detail/gamification",
      speakers: [
        {
          name: "Eko Nugroho",
          desc: "CEO of Kummara Game Studio",
          image: require("images/speakers/Eko Nugroho.jpg"),
        },
      ],
    },
    {
      title: "Women in Tech: Empathy and Humanity in Design Thinking",
      place: "Auditorium Fakultas Ilmu Komputer UI Gedung Baru",
      date: "Minggu, 15 September 2019",
      time: "14.30–16.30",
      price: "FREE",
      color: "#0088D2",
      detail: "/seminar/detail/women-in-tech",
      daftar: "/seminar/detail/women-in-tech",
      speakers: [
        {
          name: "Ananda Nadya",
          desc: "Senior UX Researcher at Tokopedia",
          image: require("images/speakers/Ananda Nadya.jpg"),
        },
        {
          name: "Aulia Chairunisa",
          desc: "UX Researcher at GRAB",
          image: require("images/speakers/Aulia Chairunisa.jpg"),
        },
        {
          name: "Windi Romania",
          desc: "UX Lead at Cashbac",
          image: require("images/speakers/Windi Romania.jpeg"),
        },
      ],
    },
    {
      title: "How a Great Startup Was Made: Let’s Start with Why!",
      place: "Balairung Universitas Indonesia",
      date: "Sabtu, 28 September 2019",
      time: "08.30–11.00",
      price: "FREE",
      color: "#0088D2",
      detail: "/seminar/detail/building-startup",
      daftar: "/seminar/detail/building-startup",
      speakers: [
        {
          name: "Darrick Rochili",
          desc: "CIO at DANA",
          image: require("images/speakers/Darrick Rochili.jpg"),
        },
        {
          name: "Rama Mamuaya",
          desc: "CEO at Dailysocial",
          image: require("images/speakers/Rama Mamuaya.jpg"),
        },
        {
          name: "Iki Sari Dewi",
          desc: "Head of 4 Wheels at GRAB",
          image: require("images/speakers/Iki Sari Dewi.jpg"),
        },
      ],
    },
    {
      title: "Boost Your Experience Limit Through Mixed Reality",
      place: "Balairung Universitas Indonesia",
      date: "Sabtu, 28 September 2019",
      time: "12.00–14.30",
      price: "FREE",
      color: "#0088D2",
      detail: "/seminar/detail/mixed-reality",
      daftar: "/seminar/detail/mixed-reality",
      speakers: [
        {
          name: "Andes Rizky",
          desc: "Founder & Managing Director at Shinta VR",
          image: require("images/speakers/Andes Rizky.jpg"),
        },
        {
          name: "Roger Fatah",
          desc: "Project Manager of MINAR",
          image: require("images/speakers/Roger Fatah.jpg"),
        },
      ],
    },
    {
      title: "How Far Away Is Indonesia from Being Cashless?",
      place: "Balairung Universitas Indonesia",
      date: "Minggu, 29 September 2019",
      time: "09.30–12.00",
      price: "FREE",
      color: "#0088D2",
      detail: "/seminar/detail/cashless-society",
      daftar: "/seminar/detail/cashless-society",
      speakers: [
        {
          name: "Yukie Iskandar",
          desc: "Head of Business Partnership at OVO",
          image: require("images/speakers/Yukie Iskandar.jpg"),
        },
        {
          name: "Kelvin Gani",
          desc: "VP of Product at MOKA",
          image: require("images/speakers/Kelvin Gani.jpeg"),
        },
        {
          name: "Norman Sasono",
          desc: "CTO at DANA",
          image: require("images/speakers/Norman Sasono.jpg"),
        },
      ],
    },
    {
      title: "Talent Gap in Tech",
      place: "Balairung Universitas Indonesia",
      date: "Minggu, 29 September 2019",
      time: "12.00–14.30",
      price: "FREE",
      color: "#0088D2",
      detail: "/seminar/detail/talent-gap",
      daftar: "/seminar/detail/talent-gap",
      speakers: [
        {
          name: "Giri Kuncoro",
          desc: "Software Engineer at GOJEK",
          image: require("images/speakers/Giri Kuncoro.jpg"),
        },
      ],
    },
  ],
};

const header = {
  dates: "14 15 21 28 29",
  month: "September 2019",
  desc:
    "Untuk meningkatan pengetahuan dan kesadaran teknologi di <i> Hyperconnected Era </i> ini, COMPFEST mempersembahkan Seminar  sebagai media edukasi yang bertujuan untuk mengedukasi masyarakat mengenai pengaruh dunia Teknologi Informasi pada kehidupan, dengan para profesional dan pakar IT.",
};

const speakers = {
  speakers: [
    {
      nama: "Yoel Sumitro1",
      jabatan: "VP Product Design, Bukalapak",
      type: "Advanced",
      imgUrl: require("images/speakers/yoelsumitro.jpg"),
    },
    {
      nama: "Yoel Sumitro2",
      jabatan: "VP Product Design, Bukalapak",
      type: "Advanced",
      imgUrl: require("images/speakers/yoelsumitro.jpg"),
    },
    {
      nama: "Yoel Sumitro3",
      jabatan: "VP Product Design, Bukalapak",
      type: "Regular",
      imgUrl: require("images/speakers/yoelsumitro.jpg"),
    },
    {
      nama: "Yoel Sumitro4",
      jabatan: "VP Product Design, Bukalapak",
      type: "Regular",
      imgUrl: require("images/speakers/yoelsumitro.jpg"),
    },
  ],
};

export default {
  seminarAdvance,
  seminar,
  header,
  speakers,
};
